import { classificationForText } from "@/lib/esco";
export function EscoBadge({ value, text }: { value: unknown; text: string }) {
  const refs = classificationForText(value, text)?.references.filter(r => r.status === "CONFIRMED") ?? [];
  return refs.length ? <span className="ml-1 text-ink-muted" title={refs.map(r => r.label).join(", ")}>· ESCO</span> : null;
}
